import createStore from 'redux-zero';
import { ISlotsItems } from './types/store/slotsItems';
import { IBudget } from './types/store/budget';
import { IRouterData } from './types/store/routerData';
import { IStore } from './types';
import { IAvailablePower } from './types/store/availablePower';

const routerData: IRouterData = {
  name: 'M4300-96X Managed Switch',
  type: 'router',
  id: 'M4300-96X',
  imageUrl: '',
  slots: {
    front: {
      height: 2,
      width: 6,
      slotsSpecs: [
        {
          name: 'frontSlot1',
          type: 'normal+plus',
          gs: 80
        },
        {
          name: 'frontSlot2',
          type: 'normal+plus',
          gs: 80
        },
        {
          name: 'frontSlot3',
          type: 'normal+plus',
          gs: 80
        },
        {
          name: 'frontSlot4',
          type: 'normal+plus',
          gs: 80
        },
        {
          name: 'frontSlot5',
          type: 'normal+plus',
          gs: 80
        },
        {
          name: 'frontSlot6',
          type: 'normal+plus',
          gs: 80
        },
        {
          name: 'frontSlot7',
          type: 'normal',
          gs: 80
        },
        {
          name: 'frontSlot8',
          type: 'normal',
          gs: 80
        },
        {
          name: 'frontSlot9',
          type: 'normal',
          gs: 80
        },
        {
          name: 'frontSlot10',
          type: 'normal',
          gs: 80
        },
        {
          name: 'frontSlot11',
          type: 'normal',
          gs: 80
        },
        {
          name: 'frontSlot12',
          type: 'normal',
          gs: 80
        }
      ]
    },
    back: {
      height: 1,
      width: 2,
      slotsSpecs: [
        {
          name: 'backSlot1',
          type: 'normal+plus'
        },
        {
          name: 'backSlot2',
          type: 'normal+plus'
        }
      ]
    }
  },
  redundantPowerSupply: true,
  maxGs: 960,
  powerConsumption: 110,
  emptySlotpowerConsumption: 5,
  proSupport: {
    remoteService: {
      allow: true,
      id: 'remoteService',
      name: 'Remote Installation Setup and Configuration Service Contract',
      region: {
        Worldwide: {
          sku: 'PSB0304-10000S'
        }
      }
    },
    onsiteService: {
      allow: true,
      id: 'onsiteService',
      name: 'Onsite Installation Setup and Configuration Service Contract',
      region: {
        Worldwide: {
          sku: 'PSP1104-10000S'
        }
      }
    }
  },
  portsSupported: ['10GBASE-T', '10GBASE-T POE+', '10G SFP+', '40G QSFP+'],
  supplySupported: ['600W PSU', '1,200W PoE PSU'],
  kits: [
    {
      id: 'M4300-96X_base',
      name: 'M4300-96X Managed Switch Empty Version',
      region: {
        Worldwide: {
          sku: 'XSM4396K0-10000S'
        }
      }
    },
    {
      id: 'M4300-96X_48xSFP+_APS600W',
      name: 'M4300-96X Managed Switch 48xSFP+ Starter Kit with APS600W PSU',
      region: {
        'North America, Europe': {
          sku: 'XSM4396K1-100NES'
        },
        'Asia Pacific': {
          sku: 'XSM4396K1-100AJS'
        }
      },
      conditions: {
        '600W PSU': 1,
        '10G SFP+': 6
      }
    }
  ]
};

const slotsItems: ISlotsItems = {
  '10GBASE-T': {
    type: 'PORT',
    howMuchLabel: 'HOW MANY 10G COPPER (10GBASE-T) PORTS?',
    simpleNameLabel: '10G Copper',
    name: '8 x 10GBASE-T Port Card',
    model: 'APM408C',
    id: '10GBASE-T',
    minWatts: 600,
    powerConsumption: 38,
    usedBy: ['normal+plus', 'normal'],
    imageUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/APM408C.png',
    imageFrontUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/switch-ports-APM408C.png',
    portsBySlot: 8,
    gsByPort: 10,
    region: {
      Worldwide: {
        sku: 'APM408C-10000S'
      }
    }
  },
  '10GBASE-T POE+': {
    type: 'PORT',
    howMuchLabel: 'HOW MANY 10G COPPER WITH POE+ (10GBASE-T POE+) PORTS?',
    simpleNameLabel: '10G Copper PoE+',
    name: '8 x 10GBASE-T PoE+ Port Card',
    model: 'APM408P',
    id: '10GBASE-T POE+',
    minWatts: 1200,
    powerConsumption: 38,
    usedBy: ['normal+plus'],
    imageUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/APM408P.png',
    imageFrontUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/switch-ports-APM408P.png',
    portsBySlot: 8,
    gsByPort: 10,
    region: {
      Worldwide: {
        sku: 'APM408P-10000S'
      }
    }
  },
  '10G SFP+': {
    type: 'PORT',
    howMuchLabel: 'HOW MANY 10G FIBER (SFP+) PORTS?',
    simpleNameLabel: '10G Fiber',
    name: '8 x 10G SFP+ Port Card',
    model: 'APM408F',
    id: '10G SFP+',
    minWatts: 600,
    powerConsumption: 23,
    usedBy: ['normal+plus', 'normal'],
    imageUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/APM408F.png',
    imageFrontUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/switch-ports-APM408F.png',
    portsBySlot: 8,
    gsByPort: 10,
    region: {
      Worldwide: {
        sku: 'APM408F-10000S'
      }
    }
  },
  '40G QSFP+': {
    type: 'PORT',
    howMuchLabel: 'HOW MANY 40G FIBER (QSFP+) PORTS?',
    simpleNameLabel: '40G Fiber',
    name: '2 x 40G QSFP+ Port Card ',
    model: 'APM402XL',
    id: '40G QSFP+',
    minWatts: 600,
    powerConsumption: 23,
    usedBy: ['normal+plus', 'normal'],
    imageUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/APM402XL.png',
    imageFrontUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/switch-ports-APM402XL.png',
    portsBySlot: 2,
    gsByPort: 40,
    region: {
      Worldwide: {
        sku: 'APM402XL-10000S'
      }
    }
  },
  '600W PSU': {
    type: 'POWER SUPPLY',
    id: '600W PSU',
    maxWatts: 600,
    poeWatts: 0,
    name: '600W PSU Unit',
    model: 'APS600W',
    usedBy: ['normal+plus', 'normal'],
    imageUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/APS600W.png',
    imageFrontUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/switch-psu-600W.png',
    region: {
      'North America, Europe': {
        sku: 'APS600W-100NES'
      },
      'Asia Pacific': {
        sku: 'APS600W-100AJS'
      }
    }
  },
  '1,200W PoE PSU': {
    type: 'POWER SUPPLY',
    id: '1,200W PoE PSU',
    maxWatts: 1200,
    poeWatts: 720,
    name: '1,200W PSU Unit',
    model: 'APS1200W',
    usedBy: ['normal+plus'],
    imageUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/APS1200W.png',
    imageFrontUrl: '/LandingsNew/M4300-96X-configurator/imagesswitch/switch-psu-1200W.png',
    region: {
      'North America, Europe': {
        sku: 'APS1200W-100NES'
      },
      'Asia Pacific': {
        sku: 'APS1200W-100AJS'
      }
    }
  }
};

const availablePower: IAvailablePower = {
  APS1200W: {
    VAC110: 1050,
    VAC220: 1200,
    and: {
      APS1200W: {
        VAC110: 2100,
        VAC220: 2400
      }
    }
  }
};

const budget: IBudget = {
  baseProduct: routerData,
  region: 'North America, Europe',
  slots: {
    back: {
      slotsSpecs: []
    },
    front: {
      slotsSpecs: []
    }
  },
  proSupport: {
    remoteService: false,
    onsiteService: false
  }
};

const initialState: IStore = { budget, slotsItems, routerData, availablePower };
const store = createStore(initialState);

export default store;



// WEBPACK FOOTER //
// ./src/store.ts